import { Header, NavTabs, Panel } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';
import { PrescriptionVisitTemplates } from '~legacy.visit';

import { settingsTranslationKeys } from '../translations';

import { DosageTemplatesTabContent } from './tabs/dosageTemplates/DosageTemplatesTabContent';
import { MagistralDrugTemplatesTabContent } from './tabs/magistralDrugTemplates/MagistralDrugTemplatesTabContent';
import { SettingsNavTabsParams } from './tabs/tabs.types';
import { VisitTemplatesTabContent } from './tabs/visitTemplates/VisitTemplatesTabContent';

export const TemplatesSettingsPanel = (): JSX.Element => {
   return (
      <Panel testId={'settings'} direction='column'>
         <Header testId={'settings'}>{settingsTranslationKeys.templates}</Header>
         <NavTabs<SettingsNavTabsParams> testId={'settings'}>
            <NavTabs.Tab
               testId={SettingsNavTabsParams.VISIT_TEMPLATES}
               param={SettingsNavTabsParams.VISIT_TEMPLATES}
               label={settingsTranslationKeys.tabs.visitTemplates}
            >
               <VisitTemplatesTabContent />
            </NavTabs.Tab>
            {protectFeature(
               ['issuingPrescriptions'],
               <NavTabs.Tab
                  testId={SettingsNavTabsParams.PRESCRIPTION_VISIT_TEMPLATES}
                  param={SettingsNavTabsParams.PRESCRIPTION_VISIT_TEMPLATES}
                  label={settingsTranslationKeys.tabs.prescriptionVisitTemplates}
               >
                  <PrescriptionVisitTemplates />
               </NavTabs.Tab>
            )}
            {protectFeature(
               'issuingPrescriptions',
               <NavTabs.Tab
                  testId={SettingsNavTabsParams.MAGISTRAL_DRUG_TEMPALTES}
                  param={SettingsNavTabsParams.MAGISTRAL_DRUG_TEMPALTES}
                  label={settingsTranslationKeys.tabs.magistralDrugTemplates}
               >
                  <MagistralDrugTemplatesTabContent />
               </NavTabs.Tab>
            )}
            {protectFeature(
               'issuingPrescriptions',
               <NavTabs.Tab
                  testId={SettingsNavTabsParams.EXTENDED_DOSAGE_TEMPLATES}
                  param={SettingsNavTabsParams.EXTENDED_DOSAGE_TEMPLATES}
                  label={settingsTranslationKeys.tabs.extendedDosageTemplates}
               >
                  <DosageTemplatesTabContent />
               </NavTabs.Tab>
            )}
         </NavTabs>
      </Panel>
   );
};
